<template>
  <v-container dark color="#241e20">
    <v-row mt-5>
      <v-col cols="12" md="6">
        <v-card
          flat
          tile
          dark
        >
          <v-list flat class="white--text">
            <v-subheader class="justify-center text-h5"><strong>Nuria Daviu Estilisme</strong></v-subheader>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-email</v-icon>
              </v-list-item-icon>
              <v-list-item-content >
                <v-btn text plain class="justify-start" href="mailto:peludaviu@hotmail.com">
                  peludaviu@hotmail.com
                </v-btn>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-phone</v-icon>
              </v-list-item-icon>
              <v-list-item-content >
                <v-btn text plain class="justify-start" href="tel:961182727">
                  961182727
                </v-btn>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-map-marker</v-icon>
              </v-list-item-icon>
              <v-list-item-content >
                <v-btn text plain class="justify-start" href="https://g.page/Nuriadaviu?share">
                  C/Ejército Español 11, Torrent, Valencia
                </v-btn>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-calendar</v-icon>
              </v-list-item-icon>
              <v-list-item-content >
                <v-list-item-title>10:00h a 19:00h: Lunes, Miércoles, Jueves y Viernes </v-list-item-title>
                <v-list-item-title>09:00h a 15:00h: Sábado </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      <v-col cols="12" md="6">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7764.880269037011!2d-0.46974876406659155!3d39.43554814578301!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9515d3488a9d6a26!2sNURIA%20DAVIU%20ESTILISME!5e0!3m2!1sen!2ses!4v1618064623951!5m2!1sen!2ses" width="380" height="300" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Contact'
  }
</script>
